<div class="element-form element mode-{{ mode }} display-{{ display }}" fxLayout="column">
  <form [formGroup]="form" *ngIf="element">

    <!-- Name -->
    <div class="row" [fxLayout]="direction">
      <div fxFlex="50" fxLayout="column">
        <mat-form-field class="name" appearance="standard">
          <sg2-element-form-breadcrumbs [element]="element" [display]="display"></sg2-element-form-breadcrumbs>
          <input matInput formControlName="name">
        </mat-form-field>
      </div>

      <!-- Extra fields outside of default form -->
      <ng-container *ngIf="mode === 'read' || mode === 'update'">
        
        <!-- Element status -->
        <div fxFlex="25" class="option option-status" fxLayout="column">
          <sg2-element-status [element]="element"></sg2-element-status>
        </div>
        
        <!-- Assigned to -->
        <div fxFlex="25" *ngIf="mode === 'read' || mode === 'update'" class="option option-assign-to" fxLayout="column">
          <sg2-element-assign-to [element]="element"></sg2-element-assign-to>
        </div>
      </ng-container>
    </div>


    <!-- Construction -->
    <!-- <h4>{{ 'general' | translate }}</h4> -->
    <div class="row" [fxLayout]="direction">

      <!-- Project level -->
      <div fxFlex="33" fxLayout="column">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'buildinglevel' | translate }}</mat-label>
          <mat-select formControlName="projectLevel">
            <mat-option *ngFor="let projectLevel of projectLevels" [value]="projectLevel._id">
              {{ projectLevel.displayName }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ 'hintBuildingLevel' | translate }}</mat-hint>
        </mat-form-field>
      </div>

      <!-- Construction -->
      <div fxFlex="33" fxLayout="column">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'construction' | translate }}</mat-label>
          <mat-select formControlName="constructionId">
            <mat-option *ngFor="let construction of constructions" [value]="construction._id">
              {{ construction.displayName || construction.name }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ 'hintConstruction' | translate }}</mat-hint>
        </mat-form-field>
      </div>

      <!-- Knowledge level -->
      <div fxFlex="33" fxLayout="column">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'knowledgedomain' | translate }}</mat-label>
          <mat-select formControlName="knowledgeLevel">
            <mat-option *ngFor="let knowledgeLevel of knowledgeLevels" [value]="knowledgeLevel._id">
              {{ knowledgeLevel.displayName }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ 'hintKnowledgeDomain' | translate }}</mat-hint>
        </mat-form-field>
      </div>

    </div>
    <hr>

    <!-- Project -->
    <h4>{{ 'document' | translate }}</h4>
    <div class="row" [fxLayout]="direction">

      <!-- Module -->
      <div fxFlex="33" fxLayout="column">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'module' | translate }}</mat-label>
          <mat-select formControlName="moduleId">
            <mat-option *ngFor="let module of modules" [value]="module._id">
              {{ module.name }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ 'hintModule' | translate }}</mat-hint>
        </mat-form-field>
      </div>

      <!-- Submodule -->
      <div fxFlex="33" fxLayout="column">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'submodule' | translate }}</mat-label>
          <mat-select formControlName="submoduleId">
            <mat-option *ngFor="let submodule of submodules" [value]="submodule._id">
              {{ submodule.name }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ 'hintSubmodule' | translate }}</mat-hint>
        </mat-form-field>
      </div>

    </div>
    <hr>

    <!-- Requirements -->
    <div class="requirements" [class.active]="form.get('requirementType').enabled">
      
      <h4>{{ 'requirement' | translate: 'plural' }}</h4>
      <div class="row" [fxLayout]="direction">

        <!-- Requirement type -->
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'requirementtype' | translate }}</mat-label>
            <mat-select formControlName="requirementType">
              <mat-option *ngFor="let type of requirementTypes" [value]="type._id">
                {{ type.displayName }}
              </mat-option>
            </mat-select>
            <mat-hint>{{ 'hintRequirementType' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <!-- Requirement strictness -->
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'requirementstrictness' | translate }}</mat-label>
            <mat-select formControlName="requirementStrictness">
              <mat-option *ngFor="let strictness of requirementStrictnesses" [value]="strictness._id">
                {{ strictness.displayName }}
              </mat-option>
            </mat-select>
            <mat-hint>{{ 'hintRequirementStrictness' | translate }}</mat-hint>
          </mat-form-field>
        </div>

      </div>
      <hr>
    </div>

    <!-- Value -->
    <h4>{{ 'value' | translate }}</h4>
    <div class="row" [fxLayout]="direction">
      
      <!-- Input type -->
      <div fxFlex="33" fxLayout="column">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'dataType' | translate }}</mat-label>
          <mat-select formControlName="inputType">
            <mat-option *ngFor="let input of inputTypes" [value]="input.value">
              {{ input.displayName }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ 'hintDataType' | translate }}</mat-hint>
        </mat-form-field>

        <!-- Input instruction -->
        <div class="input-instruction" *ngIf="form.get('inputType').value === 'Long String'" fxLayout="column">
          <mat-form-field class="instruction" fxFlex="100" *ngIf="form.get('hasInputInstruction').value" appearance="standard">
            <mat-label>{{ 'inputinstruction' | translate }}</mat-label>
            <textarea matInput
              placeholder="{{ 'inputinstruction' | translate }}"
              formControlName="inputInstruction"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5">
            </textarea>
            <mat-hint>{{ 'hintInputInstruction' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- Value -->
      <!-- Alpha numeric -->
      <ng-container *ngIf="form.value.inputType === 'String'">
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'value' | translate }}</mat-label>
            <input matInput formControlName="value">
            <span matSuffix>{{ form.value.unit }}</span>
            <mat-hint>{{ 'hintValueAlphaNumeric' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <!-- Unit -->
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'unit' | translate }}</mat-label>
            <mat-select formControlName="unit">
              <mat-option *ngFor="let unit of units" [value]="unit.value">
                {{ unit.displayName }}
              </mat-option>
            </mat-select>
            <mat-hint>{{ 'hintUnit' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Numeric -->
      <ng-container *ngIf="form.value.inputType === 'Number'">
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'value' | translate }}</mat-label>
            <input matInput [type]="{'number': form.value.inputType === 'Number'}" formControlName="value">
            <span matSuffix>{{ form.value.unit }}</span>
            <mat-hint>{{ 'hintValueNumeric' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <!-- Unit -->
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'unit' | translate }}</mat-label>
            <mat-select formControlName="unit">
              <mat-option *ngFor="let unit of units" [value]="unit.value">
                {{ unit.displayName }}
              </mat-option>
            </mat-select>
            <mat-hint>{{ 'hintUnit' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>

      <!-- Paragraph -->
      <ng-container *ngIf="form.value.inputType === 'Long String'">
        <div id="editor-container" fxFlex="66" fxLayout="column">
          <ng-container *ngIf="mode !== 'read' else paragraphReadOnly">
            <editor formControlName="value" 
              class="editor" [init]="tinyConfig" 
              [initialValue]="tinymceService.sanitizeInput(element.value)">
            </editor>
          </ng-container>
          <ng-template #paragraphReadOnly>
            <div class="editor-read-only" [innerHTML]="tinymceService.sanitizeInput(element.value) | safeHtml"></div>
          </ng-template>
        </div>
      </ng-container>

      <!-- Selection -->
      <ng-container *ngIf="form.value.inputType === 'Select'">
        <div fxFlex="33" fxLayout="column">
          <mat-form-field appearance="standard">
            <mat-label>{{ 'option' | translate: 'plural' }}</mat-label>
            <mat-select formControlName="value">

              <!-- Current value -->
              <mat-select-trigger>
                {{ form.get('value').value }}
              </mat-select-trigger>

              <!-- Options -->
              <mat-option *ngFor="let option of options" [value]="option.name">
                {{ option.name }}
                <mat-icon class="right" [class.muted]="option.name === this.form.get('value').value" (click)="deleteOption(option.name, $event)">clear</mat-icon>
              </mat-option>
              <mat-option (click)="addOption()"><em>{{ 'addoption' | translate }}</em></mat-option>

            </mat-select>
            <mat-hint>{{ 'hintValueSelection' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>
      
    </div>
    <br>

  </form>
</div>
